import { render, staticRenderFns } from "./importElementsProductModal.vue?vue&type=template&id=31b19a30&"
import script from "./importElementsProductModal.vue?vue&type=script&lang=ts&"
export * from "./importElementsProductModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports